var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer center-align"},[_vm._v(" Enduro Biking © 2023 "),_c('br'),_c('img',{staticClass:"logo",attrs:{"src":require("../../public/powered-by-strava.png"),"width":"120px"}})])
}]

export { render, staticRenderFns }